<template>
  <div class="BSCMessage" :class="`is-${type}`">
    <BSCIcon class="BSCMessage-icon" :icon="iconToDisplay" />
    <div class="BSCMessage-content">
      <span
        class="BSCMessage-title text"
        :class="`is-${type}`"
        v-if="title !== ''"
        >{{ title }}</span
      >
      <p class="BSCMessage-message">
        <slot>{{ message }}</slot>
      </p>
    </div>
  </div>
</template>

<script>
'use strict'
import BSCIcon from './BSCIcon'

export default {
  name: 'BSCMessage',
  props: {
    type: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      default: '',
    },
  },
  computed: {
    iconToDisplay() {
      return this.type === 'success'
        ? 'check'
        : this.type === 'danger'
        ? 'closeIcon'
        : 'info'
    },
  },
}
</script>
